import { render, staticRenderFns } from "./VerifiserEpost.vue?vue&type=template&id=bdf1bf2e&"
import script from "./VerifiserEpost.vue?vue&type=script&lang=js&"
export * from "./VerifiserEpost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports